document.addEventListener('DOMContentLoaded', function () {

    // Index banner slider
   const banner_slide = document.querySelector('.main_banner_slider');
    if (banner_slide) {

        const blockCount = parseInt(banner_slide.getAttribute('data-blocks'));

        new Splide(banner_slide, {
            type: 'fade',
            rewind: true,
            autoplay: true,
            interval: 3000,
            speed: 1000,
            perPage: 1,
            gap: '10px',

            // Pagination & arrows based on block count
            arrows: blockCount > 1,
            pagination: blockCount > 1,

            pauseOnHover: false,
            pauseOnFocus: false 
        }).mount(window.splide.Extensions);
    }
// Index banner slider

    // Index banner slider

    //  Custom review slider
    const splideElement = document.querySelector('.cust_reviewSlider');
    if(splideElement){
        const nav = document.querySelector('.review_nav');
        const prevBtn = document.querySelector('.review_prev');
        const nextBtn = document.querySelector('.review_next');
        const items = splideElement.querySelectorAll('.review_item').length;

        // Splide setup
        var splide = new Splide('.cust_reviewSlider', {
            type: 'slide',
            perPage: 2,
            perMove: 1,
            gap: '1.4rem',
            pagination: false,
            arrows: false,
            breakpoints: {
                640: { 
                    perPage: 1
                }
            }
        });

        splide.mount();

        // Custom Buttons
        prevBtn.addEventListener('click', () => splide.go('<'));
        nextBtn.addEventListener('click', () => splide.go('>'));

        // ---- Hide/Show Nav Based on Conditions + Add disabled class ---- //
        function updateNavVisibility() {
        const width = window.innerWidth;

        let hideNav = false;

        if (width >= 990 && items < 3) hideNav = true;
        else if (width < 640 && items < 2) hideNav = true;

        if (hideNav) {
            nav.style.display = 'none';
            prevBtn.classList.add('disabled');
            nextBtn.classList.add('disabled');
        } else {
            nav.style.display = 'flex';
            prevBtn.classList.remove('disabled');
            nextBtn.classList.remove('disabled');
        }

        updateArrowState(); // handle disabled at edges
        }

        // ---- Disable arrows when at start/end ---- //
        function updateArrowState() {
        if (nav.style.display === 'none') return; // no arrows visible

        if (splide.index === 0) {
            prevBtn.classList.add('disabled');
        } else {
            prevBtn.classList.remove('disabled');
        }

        if (splide.index === splide.length - splide.options.perPage) {
            nextBtn.classList.add('disabled');
        } else {
            nextBtn.classList.remove('disabled');
        }
        }

        updateNavVisibility();
        window.addEventListener('resize', updateNavVisibility);

        // Update arrow state on slide movement
        splide.on('move', updateArrowState);
        splide.on('mounted', updateArrowState);
    }
    //  Custom review slider


    //  Lifestyle photos slider
    const img_splideElement = document.querySelector('.life_styleSlider');
    if(img_splideElement){
        const img_nav = document.querySelector('.lifeStyle_nav');
        const img_prevBtn = document.querySelector('.lifeStyle_prev');
        const img_nextBtn = document.querySelector('.lifeStyle_next');
        const img_items = splideElement.querySelectorAll('.image_card').length;

        // Splide setup
        var img_splide = new Splide('.life_styleSlider', {
            type: 'slide',
            perPage: 3,
            perMove: 1,
            gap: '3rem',
            pagination: false,
            arrows: false,
            breakpoints: {
                 989: { 
                    gap: "2rem" 
                },
                749: { 
                    perPage: 2 
                },
                480: { 
                    perPage: 1
                }
            }
        });

        // img_splide.on('mounted move', () => {
        //     document.querySelectorAll('.image_card').forEach(slide => {
        //         slide.classList.remove('is-left-active');
        //     });

        //     const visible = document.querySelectorAll('.image_card.is-visible');

        //     if (visible.length > 0) {
        //         visible[0].classList.add('is-left-active'); // ⭐ first visible slide
        //     }
        // });

        img_splide.mount();

        // Custom Buttons
        img_prevBtn.addEventListener('click', () => img_splide.go('<'));
        img_nextBtn.addEventListener('click', () => img_splide.go('>'));

        // ---- Hide/Show Nav Based on Conditions + Add disabled class ---- //
        function img_updateNavVisibility() {
        const img_width = window.innerWidth;

        let img_hideNav = false;

        if (img_width >= 990 && img_items < 4) img_hideNav = true;
        else if (img_width < 640 && img_items < 2) img_hideNav = true;

        if (img_hideNav) {
            img_nav.style.display = 'none';
            img_prevBtn.classList.add('disabled');
            img_nextBtn.classList.add('disabled');
        } else {
            img_nav.style.display = 'flex';
            img_prevBtn.classList.remove('disabled');
            img_nextBtn.classList.remove('disabled');
        }

        img_updateArrowState(); // handle disabled at edges
        }

        // ---- Disable arrows when at start/end ---- //
        function img_updateArrowState() {
            if (img_nav.style.display === 'none') return; // no arrows visible

            if (img_splide.index === 0) {
                img_prevBtn.classList.add('disabled');
            } else {
                img_prevBtn.classList.remove('disabled');
            }

            if (img_splide.index === img_splide.length - img_splide.options.perPage) {
                img_nextBtn.classList.add('disabled');
            } else {
                img_nextBtn.classList.remove('disabled');
            }
        }

        img_updateNavVisibility();
        window.addEventListener('resize', img_updateNavVisibility);

        // Update arrow state on slide movement
        img_splide.on('move', img_updateArrowState);
        img_splide.on('mounted', img_updateArrowState);
    }
    //  Lifestyle photos slider


    // About Video Section ----------------------
    const videoSections = document.querySelectorAll('.video-sec');
    if (!videoSections.length) return;

    videoSections.forEach(function (section) {
        section.querySelectorAll('.vdo-btn-click').forEach(function (button) {
            button.addEventListener('click', function () {
                const thumbWrap = this.closest('.thumb-btn-wrap');
                const video = section.querySelector('video');

                if (!video || !thumbWrap) return;

                video.play().catch(err => console.warn('Playback blocked:', err));

                thumbWrap.style.display = 'none';

                video.addEventListener('ended', function () {
                thumbWrap.style.display = 'flex';
                });
            });
        });
    });
    // About Video Section ----------------------
});


if(document.querySelector('.index_banner_sec, .inner_banner_sec')){
    document.body.classList.add("has_banner");
};